import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Kliknij przycisk poniżej, aby przejrzeć i potwierdzić dane płatności.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'Współpracujemy ze Stripe w zakresie obsługi płatności. Stripe to najbezpieczniejsza platforma płatnicza używana przez największe firmy na świecie.',
      form: {
        terms_acceptance: {
          label:
            'Kontynuując, akceptujesz naszą <FoodAmigosTerms>Umowę o świadczenie usług</FoodAmigosTerms> oraz <StripeTerms>Umowę konta połączonego Stripe.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements:
          'Stripe oznaczył niektóre dane klienta jako brakujące lub nieprawidłowe. Napraw poniższe błędy, klikając przycisk „Otwórz profil Stripe":',
        errors: 'Błędy',
        awaiting_verification: 'Twoje konto Stripe jest weryfikowane',
        awaiting_verification_description:
          'Czekamy, aż Stripe zakończy weryfikację Twojej firmy. W międzyczasie możesz przejrzeć swój profil.',
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'Współpracujemy z Adyen w zakresie obsługi płatności. Adyen to jedna z najbezpieczniejszych platform płatniczych używanych przez największe firmy na świecie.',
    },
  },
  labels: {
    verified: 'Twoje konto {{paymentGateway}} jest zweryfikowane',
    verified_description:
      'Weryfikacja dla {{paymentGateway}} została zakończona. W razie potrzeby możesz zarządzać swoim profilem.',
  },
  buttons: {
    proceed: 'Potwierdź moje dane płatności',
    copy_link: 'Kopiuj link',
  },
  toasts: {
    something_went_wrong: 'Coś poszło nie tak, skontaktuj się z pomocą techniczną',
  },
};
